import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "list"]

  connect() {
    this.contacts = JSON.parse(this.data.get("contacts"))
    this.outsideClickListener = this.handleOutsideClick.bind(this)
    document.addEventListener("click", this.outsideClickListener)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickListener)
  }

  search() {
    const query = this.inputTarget.value.toLowerCase()

    if (!query.length) {
      this.listTarget.innerHTML = ""
      return
    }

    const results = this.contacts.filter(c => {
      const fullName = `${c.first_name} ${c.last_name}`.toLowerCase()
      const altName = (c.alt_name || "").toLowerCase()

      return fullName.includes(query) || altName.includes(query)
    }).slice(0, 10)

    this.listTarget.innerHTML = results.length ? results.map(c => {
      const displayName = this.displayName(c)

      return `
      <li class="list-group-item list-group-item-action"
          data-id="${c.id}"
          data-name="${displayName}">
        ${displayName}
      </li>
    `
    }).join("") : ""
  }

  select(event) {
    const item = event.target.closest("li")
    if (!item) return

    this.inputTarget.value = item.dataset.name
    this.hiddenTarget.value = item.dataset.id
    this.listTarget.innerHTML = ""
  }

  displayName(contact) {
    const base = `${contact.first_name} ${contact.last_name}`

    if (contact.alt_name) {
      return `${base} (${contact.alt_name})`
    }

    return base
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.listTarget.innerHTML = ""
    }
  }
}